<proffeo-ui-page-wrapper>
  <div class="w-full pt-3 lg:pt-6">
    <div class="flex w-full justify-end mb-4">
      <proffeo-ui-button
        (clicked)="openCreateOshAnalysisDialog()"
        variant="accent"
        text="{{ 'osh.add-osh-analysis' | translate }}"
        fontIcon="add"
      ></proffeo-ui-button>
    </div>
    <div
      [proffeoSpinner]="projectOshAnalyses() === undefined"
      proffeoSpinnerSize="lg"
      class="flex min-h-48 w-full flex-col gap-2 rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface p-5 max-sm:px-2"
    >
      @if (projectOshAnalyses()?.length === 0) {
        <div
          class="flex w-full items-center justify-center p-8 bg-proffeo-surface rounded-xl border border-proffeo-overlay-subtle shadow-sm"
        >
          <p class="text-proffeo-muted">{{ 'placeholders.no-results-found' | translate }}</p>
        </div>
      } @else if (projectOshAnalyses(); as analyses) {
        <proffeo-osh-tree
          (oshAnalysisEdited)="editOshAnalysis($event)"
          (oshAnalysisDeleted)="deleteOshAnalysis($event)"
          [oshAnalyses]="analyses"
        ></proffeo-osh-tree>
      }
    </div>

    <proffeo-ui-button
      (clicked)="openCreateOshAnalysisDialog()"
      variant="accent"
      fontIcon="add"
      class="button fixed bottom-10 right-10 flex cursor-pointer"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-page-wrapper>
